import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-class-admin-student-dashboard',
  templateUrl: './class-admin-student-dashboard.component.html',
  styleUrls: ['./class-admin-student-dashboard.component.scss']
})
export class ClassAdminStudentDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
